<div class="grid">
	<div [class]="col6ResponsiveButtonLayout('left')">
		<p-button id="exportDataDevice" label="{{ 'EXPORT_DATA_FROM_DEVICE' | translate }}" (click)="exportData()"
			icon="pi cm-cloud-sync" [rounded]="false" [text]="true" severity="warning"
			styleClass="font-bold border-yellow-600">
		</p-button>
	</div>
	<div [class]="col6ResponsiveButtonLayout('right')">
	</div>
</div>
<p-accordion>
	<p-accordionTab>
		<ng-template pTemplate="header">
			<div class="grid flex align-items-center w-full pt-2 -mb-2">
				<div [class]="!onExtendedMobile() ? 'col-12' : 'col-12 flex justify-content-center'" class="py-0">
					<span class="font-semibold white-space-nowrap">{{'IMPORT_DATA_INTO_DEVICE' | translate }}</span>
				</div>
			</div>
		</ng-template>
		<div>
			<app-mtma-import-export-list></app-mtma-import-export-list>
		</div>
	</p-accordionTab>
</p-accordion>